var path = '/templates/zenclerk_s/layout/footer.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/layout/footer.html
// module id = 1363
// module chunks = 0